import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadFiles (params) {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/atp/files/', { params }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async getFileDetail (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/files/${id}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async downloadATPFile (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/files/${id}/download_atp_file/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async downloadErrorFile (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/atp/files/${id}/error-doc/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async downloadFile (url, capturedId, extension) {
    try {
      const response = await axiosInstance.get(url, {
        responseType: 'blob'
      })

      const blob = new Blob([response.data])
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = downloadUrl
      a.download = `file_${capturedId}.${extension}`
      document.body.appendChild(a)
      a.click()

      window.URL.revokeObjectURL(downloadUrl)
      document.body.removeChild(a)
    } catch (error) {
      console.error('error:', error)
    }
  }

}
